module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_54.ad1737a1.png";